import React, { Component, PureComponent } from 'react'
import { Dropdown } from 'semantic-ui-react'

export default function Select(props) {
  let { options = [], name = '', id = '', onChange, placeholder = 'Valitse', value, disabled = false } = props

  let classes = ['form-input', 'form-input--select']

  return (
    <Dropdown
      placeholder={placeholder}
      options={options}
      value={value}
      disabled={disabled}
      selectOnBlur={false}
      selectOnNavigation={false}
      selection
      search
      onChange={(e, { value = false } = {}) => onChange({ name, value })}
    />
  )

  // return (
  //   <select name={ name }
  //     id={ id }
  //     value={ value }
  //     onChange={ e => onChange({name, value: e.target.value || false}) }>
  //     <option value="">
  //       {placeholder}
  //     </option>
  //     { options.map(({label, value}) => {
  //         return (
  //           <option value={ value } key={ value }>
  //             { label }
  //           </option>
  //         )
  //       }) }
  //   </select>
  // )
}
